import firebase from 'firebase'

const firebaseConfig = {
  apiKey: "AIzaSyDASvyDB5CvWypmpU_IVAVVyAmViYZALE4",
  authDomain: "facebook-clone-3449c.firebaseapp.com",
  databaseURL: "https://facebook-clone-3449c.firebaseio.com",
  projectId: "facebook-clone-3449c",
  storageBucket: "facebook-clone-3449c.appspot.com",
  messagingSenderId: "152047406433",
  appId: "1:152047406433:web:0959c7881ce286043ac920",
  measurementId: "G-HPXJWR4WTB",
};

const firebaseApp = firebase.initializeApp(firebaseConfig)

const db = firebaseApp.firestore();

const auth = firebase.auth()

const provider = new firebase.auth.GoogleAuthProvider()

export { provider, auth }
export default db